export default "__VITE_ASSET__cebB$Nfu__"